module.exports = __webpack_public_path__ + "img/calling-an-api-consumer.1c622024.png";